var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { ref, computed } from "vue";
class ArrayDataSource {
  constructor(data) {
    // Data and metas
    __publicField(this, "data", ref([]));
    __publicField(this, "computedData", ref([]));
    __publicField(this, "total", ref(0));
    __publicField(this, "pages", ref(0));
    // Query
    __publicField(this, "sort", ref(null));
    __publicField(this, "filter", ref(null));
    // Pagination
    __publicField(this, "pageSize", ref(10));
    __publicField(this, "page", ref(1));
    this.setData(data);
  }
  setData(data) {
    this.data.value = data;
  }
  setPageSize(pageSize) {
    this.pageSize.value = pageSize;
  }
  setPage(page) {
    this.page.value = page;
  }
  load() {
    let data = this.data.value;
    if (this.filter.value !== null && this.filter.value.length) {
      data = data.filter((item) => {
        for (let i = 0; i < this.filter.value.length; i++) {
          const filter = this.filter.value[i];
          if (item[filter.key].includes(filter.value)) {
            return true;
          }
        }
        return false;
      });
    }
    if (this.sort.value !== null) {
      const key = this.sort.value.key;
      const resolveSort = (a, b) => {
        if (a[key] > b[key]) {
          return 1;
        } else if (a[key] < b[key]) {
          return -1;
        }
        return 0;
      };
      data = data.sort((a, b) => {
        return this.sort.value.direction === "asc" ? resolveSort(a, b) : resolveSort(b, a);
      });
    }
    this.computedData.value = data.slice(
      (this.page.value - 1) * this.pageSize.value,
      this.page.value * this.pageSize.value
    );
    this.total.value = data.length;
    this.pages.value = Math.ceil(data.length / this.pageSize.value);
  }
  getDataAndMetas() {
    return {
      data: computed(() => this.computedData.value),
      total: computed(() => this.total.value),
      pages: computed(() => this.pages.value)
    };
  }
  sortBy(key, direction) {
    this.sort.value = key === null ? null : {
      key,
      direction
    };
  }
  search(filterExpression) {
    this.filter.value = filterExpression;
  }
}
const useArrayDatasource = (items) => {
  return new ArrayDataSource(items);
};
export {
  ArrayDataSource,
  useArrayDatasource
};
//# sourceMappingURL=datasources.es.js.map
